import { toDate } from "@suse-o11y/date-time";
import React from "react";
import { useDispatch } from "react-redux";

import { timelineUpdateRequested } from "../../../app/state/view/timeline/TimelineActions";
import { HighlightTimestampCursor } from "../../TimestampCursor";
import { InlineLink } from "../styled/StyledComponents";
import { FormatViewTime } from "../viewtime/FormatViewTime";

export interface ViewTimeLinkProps
	extends Pick<React.ComponentPropsWithRef<typeof FormatViewTime>, "time" | "hideTooltip" | "clockTimeFormat"> {
	className?: string;
}

/**
 * Makes a clickable link to jump to a time.
 * If the view is currently in live mode the time will be displayed in relative time (e.g. 5 minutes ago).
 * Otherwise the time will be shown in absolute time.
 */
export const ViewTimeLink: React.FC<ViewTimeLinkProps> = ({
	time: timestamp,
	clockTimeFormat,
	hideTooltip,
	...restProps
}) => {
	const dispatch = useDispatch();

	const handleClick = (e: React.MouseEvent): void => {
		e.preventDefault();
		e.stopPropagation();
		dispatch(timelineUpdateRequested({ timestamp: toDate(timestamp) }));
	};

	return (
		<HighlightTimestampCursor
			el={InlineLink}
			onClick={handleClick}
			shouldSetCursor
			timestamp={timestamp}
			{...restProps}
		>
			<FormatViewTime clockTimeFormat={clockTimeFormat} hideTooltip={hideTooltip} time={timestamp} />
		</HighlightTimestampCursor>
	);
};
